<!--
  CAMPO ORARIO «HH:mm» che si scrive come si scrive un orario.
  Prima c'era el-time-picker: cliccando e digitando un numero ripartiva
  dall'orario proposto (08:00) e bisognava cancellare a mano. Qui il campo è
  quello nativo del browser: «9» poi «30» fa 09:30, sopra un orario si
  riscrive direttamente, le frecce cambiano ore e minuti.
  ⚠️ Mentre si scrive il campo non si tocca da fuori: rimettere il valore a
  metà digitazione azzera i segmenti ore/minuti del browser. L'orario si
  conferma uscendo dal campo, con Invio o dopo una pausa; solo allora parte
  il calcolo (arrivo, corse successive).
  `min`: il primo orario possibile; un orario prima di quello torna lì.
-->
<template>
  <input
    ref="campo"
    type="time"
    class="jt-underline jt-time"
    :min="min || undefined"
    :disabled="disabled"
    :aria-label="etichetta"
    @input="inPausa"
    @change="inPausa"
    @blur="conferma"
    @keydown.enter.prevent="conferma"
  >
</template>

<script>
import { ref, watch, onMounted, onBeforeUnmount } from 'vue';

const valido = (v) => /^\d{2}:\d{2}$/.test(v || '');

export default {
  name: 'CampoOrario',
  props: {
    modelValue: { type: String, default: '' },
    min: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    etichetta: { type: String, default: 'Orario' },
  },
  emits: ['update:modelValue', 'change'],
  setup(props, { emit }) {
    const campo = ref(null);
    let attesa = null;

    // Il valore da fuori (es. la cascata degli orari) si scrive nel campo
    // solo quando non ci si sta scrivendo dentro.
    const mostra = (v) => {
      if (campo.value && document.activeElement !== campo.value) campo.value.value = v || '';
    };
    watch(() => props.modelValue, mostra);
    onMounted(() => mostra(props.modelValue));

    const conferma = () => {
      if (attesa) clearTimeout(attesa);
      attesa = null;
      const el = campo.value;
      if (!el) return;
      const v = el.value || '';
      if (!valido(v)) {
        // Scritto a metà o cancellato: si torna all'orario di prima.
        el.value = props.modelValue || '';
        return;
      }
      const giusto = props.min && v < props.min ? props.min : v;
      if (giusto !== v) el.value = giusto;
      if (giusto === (props.modelValue || '')) return;
      emit('update:modelValue', giusto);
      emit('change', giusto);
    };

    // Scelto dal menu del browser, o una pausa nella scrittura.
    const inPausa = () => {
      if (attesa) clearTimeout(attesa);
      attesa = setTimeout(conferma, 1500);
    };

    onBeforeUnmount(() => attesa && clearTimeout(attesa));
    return { campo, conferma, inPausa };
  },
};
</script>
